import "./Competitiontable.css";
import { useEffect, useMemo, useState } from "react";
import { useParams, NavLink } from "react-router-dom";
import backArrow from "../../../../images/arrow.png";
import whiteArrow from "../../../../images/white-arrow.png";
import Skeleton from "../../../../components/Skeleton";
import worldCup from "../../../home/HomeImage/worldcup.png";
import { Helmet } from "react-helmet-async";

const Competitiontable = ({
  dark,
  error,
  standings = [],
  loading = false,
  competition,
}) => {
  const createSlug = (leagueName) => {
    return leagueName
      ?.toLowerCase()
      .trim()
      .replace(/\s+/g, "-")
      .replace(/[^a-z0-9-]/g, "");
  };

  const currentCompetition = competition || null;

  const leagueData = competition?.league || {};
  const leagueId = leagueData?.id;
  const slug = createSlug(leagueData?.name);

  const country =
    competition?.country?.name || competition?.country || "Unknown Country";

  const currentSeason = competition?.season?.year || competition?.season || "";

  const getBorderColor = (description) => {
    if (!description) return "4px solid transparent";

    const text = description.toLowerCase();

    if (text.includes("champions")) {
      return "4px solid #16a34a";
    }

    if (text.includes("europa")) {
      return "4px solid #f97316";
    }

    if (text.includes("conference")) {
      return "4px solid #3b82f6";
    }

    if (text.includes("promotion")) {
      return "4px solid #16a34a";
    }

    if (text.includes("relegation")) {
      return "4px solid #ef4444";
    }

    if (text.includes("ranking")) {
      return "4px solid #a1a1aa";
    }

    return "4px solid transparent";
  };

  const legendTypes = useMemo(() => {
    const types = new Set();

    standings.forEach((group) => {
      const teams = Array.isArray(group) ? group : [group];

      teams.forEach((team) => {
        const desc = team?.description?.toLowerCase() || "";

        if (desc.includes("champions") || desc.includes("promotion")) {
          types.add("champions");
        }

        if (desc.includes("europa")) {
          types.add("europa");
        }

        if (desc.includes("conference")) {
          types.add("conference");
        }

        if (desc.includes("relegation")) {
          types.add("relegation");
        }

        if (desc.includes("ranking")) {
          types.add("ranking");
        }
      });
    });

    return types;
  }, [standings]);

  const [isStickyTop, setIsStickyTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.innerWidth <= 600) {
        if (window.scrollY >= 98) {
          setIsStickyTop(true);
        } else {
          setIsStickyTop(false);
        }
      } else {
        if (window.scrollY >= 300) {
          setIsStickyTop(true);
        } else {
          setIsStickyTop(false);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!currentCompetition) {
    return (
      <p style={{ padding: "8% 0" }}>
        <Skeleton dark={dark} count={6} />
      </p>
    );
  }
  return (
    <div className="homer">
      <Helmet>
        <title>
          {leagueData?.name
            ? `${leagueData.name} Standings | Tables & Rankings`
            : "Competition Standings | Tables & Rankings"}
        </title>

        <meta
          name="description"
          content={
            leagueData?.name
              ? `View the latest ${leagueData.name} standings and league table. Follow team rankings, points, wins, losses, and goals for the ${currentSeason} season in ${country} football.`
              : `View the latest football standings and league tables. Follow team rankings, points, wins, losses, and goals for the current season.`
          }
        />

        <meta
          name="keywords"
          content={
            leagueData?.name
              ? `${leagueData.name} standings, ${leagueData.name} table, football rankings, ${country} football, ${currentSeason} season, points table, soccer standings`
              : `football standings, league table, rankings, points table, soccer standings`
          }
        />

        {/* Open Graph */}
        <meta
          property="og:title"
          content={
            leagueData?.name
              ? `${leagueData.name} Standings`
              : "Football Standings"
          }
        />

        <meta
          property="og:description"
          content={
            leagueData?.name
              ? `Check updated ${leagueData.name} league table with rankings, points, and team performance for the ${currentSeason} season.`
              : `Check updated football league tables, standings, and rankings.`
          }
        />

        <meta property="og:type" content="website" />

        {/* Twitter */}
        <meta
          name="twitter:title"
          content={
            leagueData?.name
              ? `${leagueData.name} Standings`
              : "Football Standings"
          }
        />

        <meta
          name="twitter:description"
          content={
            leagueData?.name
              ? `Latest ${leagueData.name} standings, points table and team rankings for ${currentSeason}.`
              : `Latest football standings and league tables.`
          }
        />
      </Helmet>

      <div className="tableWrapper">
        {/* <NavLink
          to="/competition"
          style={{ textDecoration: "none" }}
          className="ppp">
          <strong
            style={{
              cursor: "pointer",
              backgroundColor: "transparent",
              border: dark ? "none" : "none",
              color: dark ? "white" : "black",
              padding: "5px 10px",
              borderRadius: "5px",
            }}>
            {dark ? (
              <img src={whiteArrow} alt="" className="whitearrow" />
            ) : (
              <img src={backArrow} alt="" className="blackarrow" />
            )}
          </strong>
        </NavLink>

        <section
          className="section1"
          style={
            dark
              ? { backgroundColor: "#272727ff" }
              : { backgroundColor: "whitesmoke" }
          }>
          <div>
            <img
              src={leagueData?.id === 1 ? worldCup : leagueData?.logo}
              alt={leagueData?.name}
              style={{ backgroundColor: "white" }}
            />
            <h1 style={dark ? { color: "#fafafaff" } : { color: "#161819" }}>
              {leagueData?.name}
            </h1>
          </div>

          <span>
            <strong
              style={dark ? { color: "#cececeff" } : { color: "#8F8C8C" }}>
              {country} Football
            </strong>

            <strong
              style={dark ? { color: "#cececeff" } : { color: "#8F8C8C" }}>
              Season {currentSeason}
            </strong>
          </span>

          <nav className="competition-nav">
            <ul
              className="competition-ul"
              style={
                dark
                  ? {
                      backgroundColor: "#333333ff",
                      color: "#fff",
                      width: isStickyTop ? "108%" : "100%",
                      marginLeft: isStickyTop ? "-4%" : "0",
                      transform: isStickyTop
                        ? "translateX(-4%)"
                        : "translateX(0)",
                      borderRadius: isStickyTop ? "0px" : "",
                      borderRadius: isStickyTop ? "0px" : "",
                      transition: "all 0.3s",
                    }
                  : {
                      width: isStickyTop ? "108%" : "100%",
                      transform: isStickyTop
                        ? "translateX(-4%)"
                        : "translateX(0)",
                      marginLeft: isStickyTop ? "-4%" : "0",
                      borderRadius: isStickyTop ? "0px" : "",
                      transition: "all 0.3s",
                    }
              }>
              <NavLink
                to={`/competition/${slug}/${leagueId}`}
                end
                className={({ isActive }) => (isActive ? "active" : "navlink")}>
                <li
                  style={dark ? { color: "#d1d1d1ff" } : { color: "#8F8C8C" }}>
                  Overview
                </li>
              </NavLink>

              <NavLink
                to={`/competition/${slug}/${leagueId}/news`}
                className={({ isActive }) => (isActive ? "active" : "navlink")}>
                <li
                  style={dark ? { color: "#d1d1d1ff" } : { color: "#8F8C8C" }}>
                  News
                </li>
              </NavLink>

              <NavLink
                to={`/competition/${slug}/${leagueId}/standings`}
                className={({ isActive }) => (isActive ? "active" : "navlink")}>
                <li style={{ color: "#fafafaff" }}>Tables</li>
              </NavLink>

              <NavLink
                to={`/competition/${slug}/${leagueId}/matches`}
                className={({ isActive }) => (isActive ? "active" : "navlink")}>
                <li
                  style={dark ? { color: "#d1d1d1ff" } : { color: "#8F8C8C" }}>
                  Matches
                </li>
              </NavLink>

              <NavLink
                to={`/competition/${slug}/${leagueId}/players`}
                className={({ isActive }) => (isActive ? "active" : "navlink")}>
                <li
                  style={dark ? { color: "#d1d1d1ff" } : { color: "#8F8C8C" }}>
                  Top Players
                </li>
              </NavLink>
            </ul>
          </nav>
        </section> */}

        {loading ? (
          <h2
            style={
              dark
                ? {
                    color: "#dadadaff",
                    fontSize: "18px",
                    margin: "0px 0 20px 0",
                  }
                : {
                    color: "#3E3F3F",
                    fontSize: "18px",
                    margin: "-20px 0 20px 0",
                  }
            }>
            <Skeleton dark={dark} count={6} />
          </h2>
        ) : standings.length <= 0 ? null : (
          <section className="overall">
            {competition && (
              <section className="onlysection">
                {standings.map((group, groupIndex) => (
                  <section key={groupIndex}>
                    <h4
                      id="h1"
                      style={
                        dark ? { color: "#fafafaff" } : { color: "#161819" }
                      }>
                      {group?.[0]?.group || leagueData?.name || "League"}
                    </h4>

                    <div className="tablehead">
                      <nav>
                        <h2>POS</h2>
                        <h2>TEAM</h2>
                      </nav>

                      <span>
                        <h2 style={{ color: "#fafafaff" }}>P</h2>
                        <h2 style={{ color: "#fafafaff" }}>W</h2>
                        <h2 style={{ color: "#fafafaff" }}>D</h2>
                        <h2 style={{ color: "#fafafaff" }}>L</h2>
                        <h2 style={{ color: "#fafafaff" }}>GD</h2>
                        <h2 style={{ color: "#fafafaff" }}>PTS</h2>
                      </span>
                    </div>

                    <section className="thesection">
                      {group?.map((standings, index) => (
                        <div
                          key={standings?.team?.id || index}
                          style={
                            dark
                              ? {
                                  backgroundColor:
                                    standings?.team?.id === leagueData?.id
                                      ? "#333333ff"
                                      : "#222",
                                  color: "#fff",
                                  borderRadius: "30px",
                                  boxShadow: "1px 1px 30px rgba(0,0,0,0.39)",
                                  borderLeft: getBorderColor(
                                    standings?.description,
                                  ),
                                }
                              : {
                                  borderLeft: getBorderColor(
                                    standings?.description,
                                  ),
                                }
                          }>
                          <nav>
                            <h2
                              style={
                                dark
                                  ? { color: "#fafafaff" }
                                  : { color: "#3e3f3f" }
                              }>
                              {standings?.rank}
                            </h2>

                            <h2>
                              <NavLink
                                key={index}
                                to={`/teams/${createSlug(
                                  standings?.team?.name,
                                )}-${standings?.team?.id}`}>
                                <img
                                  src={standings?.team?.logo}
                                  width="20"
                                  alt={standings?.team?.name}
                                />
                              </NavLink>

                              <NavLink
                                key={index}
                                to={`/teams/${createSlug(
                                  standings?.team?.name,
                                )}-${standings?.team?.id}`}>
                                <span
                                  className="longName"
                                  style={
                                    dark
                                      ? { color: "#fafafaff" }
                                      : { color: "#3e3f3f" }
                                  }>
                                  {standings?.team?.name}
                                </span>

                                <span
                                  className="codeName"
                                  style={
                                    dark
                                      ? { color: "#fafafaff" }
                                      : { color: "#3e3f3f" }
                                  }>
                                  {standings?.team?.code}
                                </span>
                              </NavLink>
                            </h2>
                          </nav>

                          <span>
                            <h2
                              style={
                                dark
                                  ? { color: "#fafafaff" }
                                  : { color: "#3e3f3f" }
                              }>
                              {standings?.all?.played}
                            </h2>

                            <h2
                              style={
                                dark
                                  ? { color: "#fafafaff" }
                                  : { color: "#3e3f3f" }
                              }>
                              {standings?.all?.win}
                            </h2>

                            <h2
                              style={
                                dark
                                  ? { color: "#fafafaff" }
                                  : { color: "#3e3f3f" }
                              }>
                              {standings?.all?.draw}
                            </h2>

                            <h2
                              style={
                                dark
                                  ? { color: "#fafafaff" }
                                  : { color: "#3e3f3f" }
                              }>
                              {standings?.all?.lose}
                            </h2>

                            <h2
                              style={
                                dark
                                  ? { color: "#fafafaff" }
                                  : { color: "#3e3f3f" }
                              }>
                              {standings?.goalsDiff}
                            </h2>

                            <h2
                              style={
                                dark
                                  ? { color: "#fafafaff" }
                                  : { color: "#3e3f3f" }
                              }>
                              {standings?.points}
                            </h2>
                          </span>
                        </div>
                      ))}
                    </section>

                    {legendTypes.size > 0 && (
                      <div className="elim-wrap">
                        {legendTypes.has("champions") && (
                          <div className="elim">
                            <span
                              style={{
                                width: "12px",
                                height: "12px",
                                background: "#16a34a",
                                borderRadius: "3px",
                              }}></span>
                            <small
                              style={
                                dark ? { color: "#ccc" } : { color: "#3e3f3f" }
                              }>
                              Champions League
                            </small>
                          </div>
                        )}

                        {legendTypes.has("europa") && (
                          <div className="elim">
                            <span
                              style={{
                                width: "12px",
                                height: "12px",
                                background: "#f97316",
                                borderRadius: "3px",
                              }}></span>
                            <small
                              style={
                                dark ? { color: "#ccc" } : { color: "#3e3f3f" }
                              }>
                              Europa League
                            </small>
                          </div>
                        )}

                        {legendTypes.has("conference") && (
                          <div className="elim">
                            <span
                              style={{
                                width: "12px",
                                height: "12px",
                                background: "#3b82f6",
                                borderRadius: "3px",
                              }}></span>
                            <small
                              style={
                                dark ? { color: "#ccc" } : { color: "#3e3f3f" }
                              }>
                              Conference League
                            </small>
                          </div>
                        )}

                        {legendTypes.has("relegation") && (
                          <div className="elim">
                            <span
                              style={{
                                width: "12px",
                                height: "12px",
                                background: "#ef4444",
                                borderRadius: "3px",
                              }}></span>
                            <small
                              style={
                                dark ? { color: "#ccc" } : { color: "#3e3f3f" }
                              }>
                              Relegation
                            </small>
                          </div>
                        )}

                        {legendTypes.has("ranking") && (
                          <div className="elim">
                            <span
                              style={{
                                width: "12px",
                                height: "12px",
                                background: "#a1a1aa",
                                borderRadius: "3px",
                              }}></span>
                            <small
                              style={
                                dark ? { color: "#ccc" } : { color: "#3e3f3f" }
                              }>
                              Ranking
                            </small>
                          </div>
                        )}
                      </div>
                    )}
                  </section>
                ))}
              </section>
            )}
          </section>
        )}
      </div>
    </div>
  );
};

export default Competitiontable;
